/**
 * World Cup 2026 — English (FIFA) name → Hebrew nameHe from world-cup-2026-teams.csv.
 * Used when games CSV has English names but teams were imported with Hebrew-only legacy fields.
 */
export const WC2026_EN_NORM_TO_HE = {
  algeria: 'אלג\'יריה',
  argentina: 'ארגנטינה',
  australia: 'אוסטרליה',
  austria: 'אוסטריה',
  belgium: 'בלגיה',
  'bosnia and herzegovina': 'בוסניה והרצגובינה',
  brazil: 'ברזיל',
  'cabo verde': 'כף ורדה',
  canada: 'קנדה',
  colombia: 'קולומביה',
  'congo dr': 'קונגו',
  'cote divoire': 'חוף השנהב',
  croatia: 'קרואטיה',
  curacao: 'קוראסאו',
  czechia: 'צ\'כיה',
  ecuador: 'אקוודור',
  egypt: 'מצרים',
  england: 'אנגליה',
  france: 'צרפת',
  germany: 'גרמניה',
  ghana: 'גאנה',
  haiti: 'האיטי',
  'ir iran': 'איראן',
  iraq: 'עיראק',
  japan: 'יפן',
  jordan: 'ירדן',
  'korea republic': 'דרום קוריאה',
  mexico: 'מקסיקו',
  morocco: 'מרוקו',
  netherlands: 'הולנד',
  'new zealand': 'ניו זילנד',
  norway: 'נורבגיה',
  panama: 'פנמה',
  paraguay: 'פרגוואי',
  portugal: 'פורטוגל',
  qatar: 'קטר',
  'saudi arabia': 'סעודיה',
  scotland: 'סקוטלנד',
  senegal: 'סנגל',
  'south africa': 'דרום אפריקה',
  spain: 'ספרד',
  sweden: 'שבדיה',
  switzerland: 'שווייץ',
  tunisia: 'תוניסיה',
  turkiye: 'טורקיה',
  uruguay: 'אורוגוואי',
  usa: 'ארצות הברית',
  uzbekistan: 'אוזבקיסטן',
};
